import { Accordion, AccordionItem, type AccordionItemProps } from '@seen/ui'
import { type JSX, useState } from 'react'

type DisclosureProps = {
  children: AccordionItemProps['children']
  defaultOpen?: boolean
  className?: string
}

export function Disclosure({
  children,
  defaultOpen = false,
  className,
}: DisclosureProps): JSX.Element {
  const [open, setOpen] = useState(defaultOpen ? 'default' : '')
  return (
    <Accordion
      className={className}
      type="single"
      value={open}
      onValueChange={setOpen}
      collapsible
    >
      <AccordionItem value="default" className="border-b-0">
        {children}
      </AccordionItem>
    </Accordion>
  )
}
